<template>
  <section v-if="result" class="main-slider">
    <DefSwiper>
      <SwiperSlide v-for="(item, i) in result.items" :key="i">
        <a :href="item.link || item.detailPage" class="main-slider__link">
          <div v-if="item.html">
            <DefInsertTildaSlider :result="item.html" />
          </div>
          <DefVideo v-else-if="item.video" :result="item.video" />
          <DefPicture v-else :result="item.animation || item.pictures" />
        </a>
      </SwiperSlide>
    </DefSwiper>
    <!--    <swiper :modules="modules" :slides-per-view="1" :pagination="{ clickable: true }" navigation>-->
    <!--      <swiper-slide v-for="(item, i) in result.items" :key="i">-->
    <!--        <a :href="item.link || item.detailPage" class="main-slider__link">-->
    <!--          <div v-if="item.html">-->
    <!--            <DefInsertTildaSlider :result="item.html" />-->
    <!--          </div>-->
    <!--          <DefVideo v-else-if="item.video" :result="item.video" />-->
    <!--          <DefPicture v-else :result="item.animation || item.pictures" />-->
    <!--        </a>-->
    <!--      </swiper-slide>-->
    <!--    </swiper>-->
  </section>
</template>

<script>
import { SwiperSlide } from 'swiper/vue';

import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import DefSwiper from '@components/Def/DefSwiper/DefSwiper.vue';
import DefInsertTildaSlider from '../Def/DefInsertTilda/DefInsertTildaSlider';

export default {
  name: 'MainSlider',
  components: {
    DefPicture,
    DefVideo,
    SwiperSlide,
    DefInsertTildaSlider,
    DefSwiper,
  },
  props: {
    result: {
      // type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.main-slider {
  margin-bottom: 56px;
  @include point-md {
    margin-bottom: 80px;
  }
  @include point-lg {
    margin-bottom: 100px;
  }
  &__link {
    display: block;
  }
  :deep(.def-swiper-button-prev) {
    left: 12px;
    transform: translate(0, -50%);
    @include point-md {
      left: 24px;
    }
    @include point-lg {
      left: 50px;
    }
  }
  :deep(.def-swiper-button-next) {
    right: 12px;
    transform: translate(0, -50%);
    @include point-md {
      right: 24px;
    }
    @include point-lg {
      right: 50px;
    }
  }
  :deep(.swiper-pagination) {
    margin-top: 0;
    position: absolute;
    bottom: 8px;
    z-index: 1;
    @include point-md {
      bottom: 16px;
    }
  }
}
</style>
